define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'router', 'scroll', 'slider', 'jump'],
    function ($, transit, modernizr, container, preloader, router, scroll, sliderFactory, jumpFactory) {

        var module = (function () {

            var name = 'module-home-header';

            var model = container.getBaseModel(name);
            var view = container.getBaseView(name);
            var pubSub = container.getPublishSubscribe();
            const slider = sliderFactory.create()
            const jump = jumpFactory.create();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {};

            /* view */

            view.publicVars = {};

            view.privateVars = {

            };

            view.startup = function () {
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.homeHeaderMediaCarouselArrowLeftId, 'animate__slideInLeft', 'home-header', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.homeHeaderMediaCarouselArrowRightId, 'animate__slideInRight', 'home-header', {});
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.homeHeaderMediaCarouselButtonCls, 'animate__zoomIn', 'home-header', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.homeHeaderMediaCarouselArrowScrollId, 'animate__zoomIn', 'home-header', {});
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.headerLogoWrapperCls, 'animate__bounce', 'header', {});
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.headerContentBottomCls, 'animate__slideInUp', 'header', {});

                slider.init(view.publicVars.sliderSetup);
            };

            view.bind = function () {
                $(view.publicVars.cssId.homeHeaderMediaCarouselArrowScrollId).click(function () {

                    const headerHeightModifier = $(view.publicVars.cssId.headerCls).outerHeight();

                    jump.jumpTo(view.publicVars.cssId.moduleHomeCompanyId, {modifier: -headerHeightModifier, speed: 300});
                });
            };

            view.methods = {
                setCallbacks: (callbacks) => {
                    view.privateVars.callbacks = callbacks;
                }
            };

            /* custom events */

            // pubSub.subscribe('view/updateCharacterContent', view.methods.updateCharacterContent);

            //pubSub.subscribe('view/updateSuccessLikes', view.methods.updateSuccessLikes);
            //pubSub.subscribe('view/updateSuccessViews', view.methods.updateSuccessViews);

            /* public methods */
            return {
                init: function (options, callbacks) {
                    view.methods.setCallbacks(callbacks);
                    model.init(options);
                    view.init(options);
                    scroll.init();
                }
            };


        })();


        return module;

    });